import axios from 'axios';
import _ from 'lodash';
import Vue from 'vue';
import store from '@/store';
// import router from '@/router';
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import authorization from './authorization';

// Init plugin
Vue.use(Loading, { loader: 'bars', color: '#1a8482', height: 128, width: 128 });

const baseURL = process.env.VUE_APP_API_URL;

let apiStatus = {};

let loadingCount = 0;

let loader;

const toggleLoading = (display, displayLoading) => {
  if (!displayLoading) return;

  if (display) {
    loadingCount++;
  } else {
    loadingCount--;
  }

  if (loadingCount > 0) {
    if (!loader) {
      loader = Vue.$loading.show();
    }
  } else {
    loadingCount = 0;
    if (loader === undefined) {
      return;
    }
    loader.hide();
    loader = undefined;
  }
};

// debounce 可以延遲執行 ,一定要包在function裡面
const debounceErrorAlert = _.debounce(() => {
  alert('伺服器連線異常');
}, 500);

// 參數cb:打以下這個api的function的function,成功拿到回傳值的動作
// 參數errCb:打以下這個api的function的function,失敗拿到回傳message的動作
export default ({
  method,
  url,
  config = {},
  cb,
  errCb,
  displayLoading = true
}) => {
  let isStillGetting = _.get(apiStatus, url, false);

  if (isStillGetting) {
    return;
  }

  _.set(apiStatus, url, true);

  let defaultConfig = {
    baseURL,
    method,
    url,
    ...authorization()
  };

  let usingConfig = Object.assign(defaultConfig, config);

  // 呼叫api前,開啟loading圖示
  toggleLoading(true, displayLoading);

  axios(usingConfig)
    .then(response => {
      // api的值回來後,移除apiStatus物件下, url路徑
      _.unset(apiStatus, url);

      // api的值回來後,關閉loading圖示
      toggleLoading(false, displayLoading);

      const code = _.get(response, 'data.status.code');

      const data = _.get(response, 'data.data');

      const message = _.get(response, 'data.status.message');

      if (code == '1') {
        if (cb) {
          cb(data);
        }
      } else if (code == 401) {
        store.dispatch('user/logout');
      } else {
        if (errCb) {
          if (
            // 報到失敗
            code == 20002 ||
            code == 40001 ||
            code == 40002 ||
            code == 40003 ||
            code == 40004 ||
            code == 40022 ||
            code == 40023
          ) {
            errCb(code);
          } else {
            errCb(message);
          }
        } else {
          alert(message);
        }
      }
    })
    .catch(error => {
      // api失敗後,移除apiStatus物件下, url路徑
      _.unset(apiStatus, url);

      // api失敗後,關閉loading圖示
      toggleLoading(false, displayLoading);

      // eslint-disable-next-line no-console
      console.error(error);

      const status = _.get(error, 'response.status');

      // const code = _.get(error, 'response.data.status.code');

      if (status == 401) {
        // 觸發Vuex的會員登出
        store.dispatch('user/logout');
        return;
      }

      const message = _.get(error, 'response.data.status.message');

      if (message) {
        if (errCb) {
          errCb(message);
        } else {
          alert(message);
        }
      } else {
        // 0.5秒後報錯
        debounceErrorAlert();
      }
    });
};
